import { getDocumentPDF } from '@/services/getDocumentsHistory';
import { useMutation } from '@tanstack/react-query';
import { useToastNotification } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoadingSpinner } from '@/components';
import styles from './DocumentsHistoryTable.module.scss';

interface DownloadPdfDocumentProps {
  oid: number;
  contenedor?: string;
}
export const DownloadPdfDocument = (props: DownloadPdfDocumentProps) => {
  const { oid, contenedor } = props;
  const { showToast } = useToastNotification();
  const { t } = useTranslation('cfe');

  const downloadPdf = (data: string) => {
    if (!data) return;
    const byteCharacters = atob(data.replace(/-/g, '+').replace(/_/g, '/'));
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i += 1) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = `${contenedor ?? 'downloaded_document'}.pdf`;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  };

  const generatePDFMutation = useMutation({
    mutationFn: getDocumentPDF,
    onSuccess: (response) => {
      downloadPdf(response.data.value);
    },
    onError: (error) => {
      if (error.toString().trim() !== 'Error') {
        showToast({ severity: 'error', detail: `${error}` });
      } else {
        showToast({
          severity: 'error',
          detail: t('cfeFormValidations.unexpectedError'),
        });
      }
    },
  });

  const handleClick = async () => {
    generatePDFMutation.mutate({ guid: oid.toString() });
  };

  if (generatePDFMutation.isPending)
    return (
      <div className={styles.spinnerContainer}>
        <LoadingSpinner size="tiny" />
      </div>
    );
  return (
    <FontAwesomeIcon
      onClick={handleClick}
      icon={faFilePdf}
      style={{ cursor: 'pointer' }}
    />
  );
};
